<template>
  <div class="home">
    <!--顶部导航-->
<!--    <navBar class="navbar"></navBar>-->
<!--    大背景-->
<!--    <div class="bigBackground">-->
<!--    </div>-->
<!--    <div>-->
<!--      <img src="@/assets/img/pc/index/pic1_4.png" width="100%">-->
<!--    </div>-->
    <div class="line-container">
      <picture>
        <source media="(min-width: 768px)" srcset="@/assets/img/pc/index/pic1_4.png">
        <source media="(min-width: 320px)" srcset="@/assets/img/mobile/index/pic1_4.png">
        <img src="@/assets/img/pc/index/pic1_4.png">
      </picture>
    </div>
    <!--主体布局-->
    <div class="x-container" style="padding-top: 0">
      <!--半球背景-->
      <div class="world"></div>
      <!--产品架构-->
      <section class="x-section" style="padding-top: 3rem;">
        <p class="x-title">产品架构</p>
        <div>
          <img src="@/assets/img/pc/index/homePage1.png" width="100%">
          <img src="@/assets/img/pc/index/homePage2.png" width="100%">
        </div>
      </section>
      <!--行业应用-->
      <section class="x-section" style="padding-top: 3rem;">
        <p class="x-title">行业应用</p>
        <div>
          <img src="@/assets/img/pc/index/homePage3.png" width="100%">
        </div>
      </section>
      <!--GMOS操作系统-->
      <!--<section class="x-section" style="padding-top: 3rem;">-->
      <!--  <p class="x-title">GMOS操作系统</p>-->
      <!--  <div>-->
      <!--    <img src="@/assets/img/pc/index/GMOS1.png" width="100%">-->
      <!--  </div>-->
      <!--</section>-->
      <!--GMLink网络控制器-->
<!--      <section class="x-section" style="padding-top: 1rem;">-->
<!--        <p class="x-title">GMLink网络控制器</p>-->
<!--        <div>-->
<!--&lt;!&ndash;          <img src="@/assets/img/pc/index/GMOS2.png" width="100%">&ndash;&gt;-->
<!--          <a href="http://gbms.gree.com/#/product/productDetails/27">-->
<!--            <img src="@/assets/img/pc/index/GMOS2.png" width="100%">-->
<!--          </a>-->
<!--        </div>-->
<!--      </section>-->
      <!--GMOS生态社区-->
      <!--<section class="x-section" style="padding-top: 1rem;">-->
      <!--  <p class="x-title">GMOS生态社区</p>-->
      <!--  <div>-->
      <!--    <img src="@/assets/img/pc/index/GMOS3.png" width="100%">-->
      <!--  </div>-->
      <!--</section>-->
      <!--图形化开发软件-->
<!--      <section class="x-section" style="padding-top: 1rem;">-->
<!--        <p class="x-title">图形化开发软件</p>-->
<!--        <div>-->
<!--&lt;!&ndash;          <img src="@/assets/img/pc/index/GMOS4.png" width="100%">&ndash;&gt;-->
<!--          <a href="http://gbms.gree.com/#/product/productDetails/23">-->
<!--            <img src="@/assets/img/pc/index/GMOS4.png" width="100%">-->
<!--          </a>-->
<!--        </div>-->
<!--      </section>-->
      <!--GMOS生态开发平台-->
<!--      <section class="x-section" style="padding-top: 1rem;">-->
<!--        <p class="x-title">GMOS生态开发平台</p>-->
<!--        <div>-->
<!--&lt;!&ndash;          <img src="@/assets/img/pc/index/GMOS5.png" width="100%">&ndash;&gt;-->
<!--          <a href="http://gbms.gree.com/#/product/productDetails/24">-->
<!--            <img src="@/assets/img/pc/index/GMOS5.png" width="100%">-->
<!--          </a>-->
<!--        </div>-->
<!--      </section>-->
<!--      <section class="solution x-section">-->
<!--        <p class="x-title" style="position:relative;top: 3.4rem;margin-bottom: 6rem">行业应用</p>-->
<!--        <div>-->
<!--          <el-row>-->
<!--            <el-col v-for="(item,index) in product" :key="'product'+index" :span="8">-->
<!--              <img @click="jump(item.routerName)" class="product-img" :src="item.imgSrc" alt="" width="50%">-->
<!--              <p class="product-title">{{item.label}}</p>-->
<!--            </el-col>-->
<!--          </el-row>-->
<!--        </div>-->
<!--        <div style="margin-top: 1rem">-->
<!--          <img src="@/assets/video/GB.gif" width="100%">-->
<!--          <p >*工程实际效果</p>-->
<!--        </div>-->

<!--        <div class="solution-video">-->
<!--          <div class="video-box">-->
<!--            <video controls preload="auto" poster="../assets/img/common/video.png">-->
<!--              <source src="../assets/video/solution.mp4">-->
<!--              <p>您的浏览器暂不支持 HTML5 video标签</p>-->
<!--            </video>-->
<!--          </div>-->
<!--        </div>-->
<!--      </section>-->
    </div>
  </div>
</template>

<script>
  // import navBarBottom from '@/components/navBarBottom'
  import { selectProductCenters } from "../api/productHub";

  export default {
    name: 'home',
    components: {
    },
    data() {
      return {
        input: '',
        // 动态存储产品路由
        productRouter: {
          // '智慧传感器': 'solution1'
          '智慧楼宇': 'solution/solutionDetails/21',
          '智慧园区': 'solution/solutionDetails/20',
          '其他': ''
        },
        product: [
          // {imgSrc: require("../assets/img/pc/index/product2.png"), label: 'G-BMS平台', routerName: 'solution1'},
          {imgSrc: require("../assets/img/pc/index/GMOS6-1.png"), label: '智慧楼宇', routerName: '智慧楼宇'},
          {imgSrc: require("../assets/img/pc/index/GMOS6-2.png"), label: '智慧园区', routerName: '智慧园区'},
          {imgSrc: require("../assets/img/pc/index/GMOS6-3.png"), label: '其他'},
          // {imgSrc: require("../assets/img/pc/index/product3.png"), label: '智慧暖通', routerName: 'product3'},
        ],
        // 解决方案轮播图
        mySwiper1: null,
        carousels: [
          // {
          //   imgSrc: require("../assets/img/pc/index/carousel4.png"),
          //   imgSrcMobile: require("../assets/img/mobile/index/carousel4.png"),
          //   label: 'GBMS平台',
          //   routerName:'solution1'
          // },
          {
            imgSrc: require("../assets/img/pc/index/GMOS6-1.png"),
            imgSrcMobile: require("../assets/img/mobile/index/carousel5.png"),
            label: '智慧楼宇',
            routerName:'/solution/solutionDetails/21'
          },
          {
            imgSrc: require("../assets/img/pc/index/GMOS6-2.png"),
            imgSrcMobile: require("../assets/img/mobile/index/carousel6.jpg"),
            label: '智慧园区',
            routerName:'/solution/solutionDetails/20'
          },
          {
            imgSrc: require("../assets/img/pc/index/GMOS6-3.png"),
            imgSrcMobile: require("../assets/img/mobile/index/carousel1.png"),
            label: '其他',
            routerName:''
          },
        ],
        // 工程案例轮播图
        mySwiper2: null,
        carousels2: [
          {
            "pic1": {
              imgSrc: require("../assets/img/pc/index/engineering/gree.png"),
              imgSrcMobile: require("../assets/img/mobile/index/engineering/gree.png"),
              label: '珠海格力总部商用研发大楼'
            },
            "pic2": {
              imgSrc: require("../assets/img/pc/index/engineering/shate.png"),
              imgSrcMobile: require("../assets/img/mobile/index/engineering/shate.png"),
              label: '沙特达曼办公楼'
            },
            "pic3": {
              imgSrc: require("../assets/img/pc/index/engineering/aisidun.png"),
              imgSrcMobile: require("../assets/img/mobile/index/engineering/aisidun.png"),
              label: '南京埃斯顿办公楼'
            },
            "pic4": {
              imgSrc: require("../assets/img/pc/index/engineering/jichang.png"),
              imgSrcMobile: require("../assets/img/mobile/index/engineering/jichang.png"),
              label: '广州白云国际机场 '
            }
          },
          {
            "pic1": {
              imgSrc: require("../assets/img/pc/index/engineering/feicheng.png"),
              imgSrcMobile: require("../assets/img/mobile/index/engineering/feicheng.png"),
              label: '美国费城'
            },
            "pic2": {
              imgSrc: require("../assets/img/pc/index/engineering/ditie.png"),
              imgSrcMobile: require("../assets/img/mobile/index/engineering/ditie.png"),
              label: '成都地铁四号线'
            },
            "pic3": {
              imgSrc: require("../assets/img/pc/index/engineering/guangzhou.png"),
              imgSrcMobile: require("../assets/img/mobile/index/engineering/guangzhou.png"),
              label: '华南理工大学'
            },
            "pic4": {
              imgSrc: require("../assets/img/pc/index/engineering/hefei.png"),
              imgSrcMobile: require("../assets/img/mobile/index/engineering/hefei.png"),
              label: '合肥青网科技产业园 '
            }
          },
        ],
        // 轮播图选项
        // 一行显示多少张图片
        slidesPerView: 3,
        slidesPerGroup: 3
      }
    },
    methods: {
      getProductRouter() {
        selectProductCenters().then(res => {
          if (res.returnCode==='100') {
            let dataArr = res.returnData;
            let item2 = dataArr[2].columnIdAndName.filter(item => {
              return item.columnName === '智慧园区';
            });
            if (item2.length > 0) {
              this.productRouter['智慧园区'] = '/solution/solutionDetails/'+item2[0].id;
            }
            //GMLink网络控制器
            let item1 = dataArr[2].columnIdAndName.filter(item => {
              return item.columnName === '智慧楼宇';
            });
            if (item1.length > 0) {
              this.productRouter['智慧楼宇'] = '/solution/solutionDetails/'+item1[0].id;
            }
            let item3 = dataArr[3].columnIdAndName.filter(item => {
              return item.columnName === 'Gbuilding应用开发软件';
            });
            if (item3.length > 0) {
              this.productRouter['Gbuilding应用开发软件'] = '/product/productDetails/'+item3[0].id;
            }
          }
        }).catch(e => e);
      },
      // 点击解决方案轮播小图
      clickSolution(routerName){
        this.$router.push({name:routerName})
      },
      // 产品展示页面跳转
      jump(routerName) {
        let aimRouter = this.productRouter[routerName];
        this.$router.push(aimRouter)
      },
      // 跳转到工程应用页面
      more() {
        this.$router.push({name: 'engineering'})
      },
      // 初始化解决方案轮播图
      initSwiperSolution() {
        this.mySwiper1 = new this.$Swiper('.swiper-container1', {
          autoplay: {
            disableOnInteraction: false,
          },
          spaceBetween: 6,
          delay: 1000,
          loop: true,
          slidesPerView: 1,
          slidesPerGroup: 1,
          speed: 1000,
          grabCursor: true,
          breakpoints: {
            320: {
              // autoplay: true,
              // loop: true,
              slidesPerView: 3,
              slidesPerGroup: 1,
            }
          }
        })
      },
      // 初始化工程案例轮播图
      initSwiperProjects() {
        this.mySwiper2 = new this.$Swiper('.swiper-container2', {
          autoplay: false,
          // autoplay:{
          //   disableOnInteraction:false,
          // },
          spaceBetween: 6,
          delay: 1000,
          loop: true,
          slidesPerView: 1,
          slidesPerGroup: 1,
          speed: 1000,
          grabCursor: true,
          breakpoints: {
            320: {
              // autoplay: true,
              // loop: true,
              slidesPerView: 1,
              slidesPerGroup: 1,
            }
          }
        })
      },
      // 解决方案轮播图左滑
      prevPic() {
        this.mySwiper1.slidePrev();
      },
      // 解决方案轮播图右滑
      nextPic() {
        this.mySwiper1.slideNext();
      },
      // 工程案例轮播图左滑
      prevPic2() {
        this.mySwiper2.slidePrev();
      },
      // 工程案例轮播图右滑
      nextPic2() {
        this.mySwiper2.slideNext();
      },
    },
    created() {
      this.getProductRouter();
    },
    mounted() {
      this.$nextTick(()=>{
        this.initSwiperSolution();
        this.initSwiperProjects();
      })
      // window.addEventListener('resize', this.changeCarouselNum)
    }
  }
</script>
<style scoped lang="less">
  .home {
    position: relative;
    /*顶部导航*/
    .navbar {
      position: relative;
      z-index: 999;
      /*overflow: hidden;*/
    }
    /*首页大背景图*/
    .bigBackground {
      /*overflow: hidden;*/
      background: url("../assets/img/pc/index/pic1_4.png");
      background-size: cover;
      background-position: center center;
      height: calc(100vh - 3.5rem);
      line-height: calc(100vh - 1.5rem);
      width: 100%;
      text-align: center;
      position: relative;
      .line-container {
      position: absolute;
        left: 0;
        right: 0;
        display: inline-block;
        text-align: center;
        img {
          width: 60%;
        }
      }
    }
    /*主体布局内容*/
    .x-container {
      width: 67%;
      margin: auto;
      .world {
        height: 15rem;
        width: 100%;
        position: absolute;
        background: url("../assets/img/pc/index/world.png");
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
      }
      /*产品展示*/
      .product {
        position: relative;
        box-sizing: border-box;
        /*background: url("../assets/img/pc/index/world.png");*/
        background-repeat: no-repeat !important;
        background-position: center center !important;
        .title {
          margin-bottom: 4rem;
        }
        .product-img {
          cursor: pointer;
          width: 100%;
          max-width: 224px;
          &:hover {
            transform: scale(1.1);
            transition: 0.5s;
          }
        }
        .product-title {

        }
      }
      /*解决方案*/
      .solution {
        /*视频*/
        .solution-video {
          margin-top: 20px;
          width: 100%;
          .video-box {
            video {
              width: 100%;
            }
          }
        }
        /*轮播图*/
        .carousel {
          width: 100%;
          margin: 18px auto;
          display: flex;
          .caousel-btn {
            cursor: pointer;
            height: 0%;
            width: 1.5%;
          }
          .caousel-btn-left {
            margin-right: 0.5%;
          }
          .caousel-btn-right {
            margin-left: 0.5%;
          }
          .swiper-container {
            width: 95%;
            .swiper-wrapper {
              width: auto;
              .swiper-slide {
                position: relative;
                img {
                  width: 100%;
                  height: 100%;
                }
                .img-label {
                  background: rgba(17, 17, 17, 0.55);
                  color: #fff;
                  position: absolute;
                  bottom: 0;
                  width: 100%;
                  height: 3rem;
                  line-height: 3rem;
                }
              }
            }
          }
        }
      }
      /*工程案例*/
      .projects {
        width: 100%;
        overflow: hidden;
        /*轮播图*/
        .carousel {
          width: 100%;
          margin: 18px auto;
          display: flex;
          align-items: center;
          .caousel-btn {
            cursor: pointer;
            height: 0%;
            width: 3%;
          }
          .caousel-btn-left {
            margin-right: 0.5%;
          }
          .caousel-btn-right {
            margin-left: 0.5%;
          }
          .swiper-container {
            width: 95%;
            .swiper-wrapper {
              width: auto;
              .swiper-slide {
                position: relative;
                .onePic {
                  position: relative;
                  width: 50%;
                  float: left;
                  img {
                    width: 100%;
                    height: 100%;
                  }
                  .img-label {
                    background: rgba(17, 17, 17, 0.55);
                    color: #fff;
                    position: absolute;
                    bottom: 0;
                    width: 100%;
                    height: 3rem;
                    line-height: 3rem;
                  }
                }
              }
            }
          }
        }
        /*了解更多按钮*/
        .x-btn {
          display: inline-block;
          color: #fff;
          background-image: linear-gradient(to right, rgb(112, 68, 249), rgb(84, 106, 238));
          width: 5.5rem;
          border-radius: 50px;
          padding: 0.5rem 2rem 0.5rem 2rem;
          margin-top: 3rem;
          cursor: pointer;
        }
      }
    }
  }
</style>

<style lang="less">
  @media only screen and (min-width: 10px) and(orientation: portrait) {
    .home {
      .bigBackground {
        background: url('../assets/img/mobile/index/pic1_4.png') !important;
        background-size: cover !important;
        background-position: center center !important;
        height: 31vh !important;
        line-height: 31vh !important;
      }
    }
  }

  @media only screen and (min-width: 320px) and(orientation: portrait) {
    .home {
      /*首页大背景图*/
      .bigBackground {
        background: url('../assets/img/mobile/index/pic1_4.png') !important;
        background-size: cover !important;
        background-position: center center !important;
        height: 40vh !important;
        line-height: 40vh !important;
        /*top: -1rem !important;*/
        .line-container {
          img {
            width: 90% !important;
          }
        }
      }
      .x-container {
        /*width: 90% !important;*/
        /*产品展示*/
        .product {
          /*background: url("../assets/img/mobile/index/world.png")!important;*/
        }
        /*解决方案*/
        .solution {
          /*轮播图*/
          .carousel {
            .caousel-btn {
              display: none !important;
            }
          }
          .swiper-container {
            width: 100% !important;
          }
        }
        /*工程案例*/
        .projects {
          /*轮播图*/
          .carousel {
            .caousel-btn {
              display: none !important;
            }
            .swiper-container {
              width: 100% !important;
            }
          }
        }
      }
      /*底部导航*/
      .navBarBottom {
        display: none !important;
      }
    }
  }

  @media only screen and (min-width: 640px) and(orientation: portrait) {
    .home {
      .bigBackground {
        background: url('../assets/img/mobile/index/pic1_4.png') !important;
        background-size: cover !important;
        background-position: center center !important;
        height: 45vh !important;
        line-height: 45vh !important;
        /*top: -1rem !important;*/
        .line-container {
          img {
            width: 70% !important;
          }
        }
      }
    }
  }

  @media only screen and (min-width: 768px) and(orientation: portrait) {
    .home {
      .bigBackground {
        height: 60vh !important;
        line-height: 60vh !important;
        background-size: cover !important;
        background-position: center center !important;
        /*top: 0 !important;*/
        .line-container {
          img {
            width: 90% !important;
          }
        }
      }
      .x-container {
        .product {
          /*background: url("../assets/img/pc/index/world.png")!important;*/
        }
        /*解决方案*/
        .solution {
          /*轮播图*/
          .carousel {
            .caousel-btn {
              display: block !important;
            }
          }
          .swiper-container {
            width: 100% !important;
          }
        }
        /*工程案例*/
        .projects {
          /*轮播图*/
          .carousel {
            .caousel-btn {
              display: block !important;
            }
            .swiper-container {
              width: 100% !important;
            }
          }
        }
      }
      /*底部导航*/
      .navBarBottom {
        display: block !important;
      }
    }
  }

  @media only screen and (min-width: 1025px) and(orientation: portrait) {
    .home {
      /*首页大背景图*/
      .bigBackground {
        background: url('../assets/img/pc/index/pic1_4.png') !important;
        background-size: cover !important;
        background-position: center center !important;
        height: calc(100vh  - 4.5rem) !important;
        line-height: calc(100vh - 1.5rem) !important;
        .line-container {
          img {
            width: 100% !important;
          }
        }
      }
    }
  }

  @media only screen and (min-width: 1280px) and(orientation: portrait) {
    .home {
      /*首页大背景图*/
      .bigBackground {
        .line-container {
          img {
            width: 65% !important;
          }
        }
      }
    }
  }

  @media only screen and (min-width: 1366px) and(orientation: portrait) {
    .home {
      /*首页大背景图*/
      .bigBackground {
        .line-container {
          img {
            width: 60% !important;
          }
        }
      }
    }
  }
</style>

